import { useI18n, languageNames } from '../i18n/index.jsx';

export default function LanguageSelector({ compact = false }) {
  const { lang, setLang, languages } = useI18n();

  if (compact) {
    return (
      <select 
        value={lang} 
        onChange={(e) => setLang(e.target.value)}
        className="lang-select-compact"
      >
        {languages.map(l => (
          <option key={l} value={l}>{l.toUpperCase()}</option>
        ))}
      </select>
    );
  }

  return (
    <div className="lang-selector">
      {languages.map(l => (
        <button
          key={l}
          className={`lang-btn ${lang === l ? 'active' : ''}`}
          onClick={() => setLang(l)}
        >
          {languageNames[l]}
        </button>
      ))}
    </div>
  );
}
